/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StediPayer } from './StediPayer';
import {
    StediPayerFromJSON,
    StediPayerFromJSONTyped,
    StediPayerToJSON,
    StediPayerToJSONTyped,
} from './StediPayer';

/**
 * 
 * @export
 * @interface GetStediPayers200Response
 */
export interface GetStediPayers200Response {
    /**
     * 
     */
    data?: Array<StediPayer>;
}

/**
 * Check if a given object implements the GetStediPayers200Response interface.
 */
export function instanceOfGetStediPayers200Response(value: object): value is GetStediPayers200Response {
    return true;
}

export function GetStediPayers200ResponseFromJSON(json: any): GetStediPayers200Response {
    return GetStediPayers200ResponseFromJSONTyped(json, false);
}

export function GetStediPayers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStediPayers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StediPayerFromJSON)),
    };
}

export function GetStediPayers200ResponseToJSON(json: any): GetStediPayers200Response {
    return GetStediPayers200ResponseToJSONTyped(json, false);
}

export function GetStediPayers200ResponseToJSONTyped(value?: GetStediPayers200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StediPayerToJSON)),
    };
}

